@if (updateService.updateAvailable()) {
    <div [animate.enter]="'slide-in'" [animate.leave]="'slide-out'" class="update-bar flex flex-col">
        <p>Update available. Reload now?</p>

        <div class="flex flex-row gap-4 items-center">
            <button (click)="updateService.applyUpdate()">
                Reload
            </button>

            <a class="underline" (click)="updateService.dismissUpdate()">Dismiss</a>
        </div>
    </div>
}
